import ButtonGroup from '../../general/ButtonGroup'
import React from 'react'
import colors from '../../colors'
import { Button, Card, Grid, TextField, Typography } from '@mui/material'
import { InputAdornment } from '@mui/material'
import {selectP2PState, clearP2PSliceState, changeConfirmationDialogState} from '../../../features/p2p/p2pSlice'
import { selectGlobalDataState, setGeneralMessage, setTransactionHasBeenMade } from '../../../features/global/globalDataSlice'
import { selectUserInfo } from '../../../features/userInfo/userInfoSlice'
import { useSelector, useDispatch } from 'react-redux'
import { sendGeneralRequest } from '../../../features/generalRequest'
import { useFormik } from 'formik'
import * as yup from 'yup'
import { makeStyles } from '@mui/styles';
import smallLoadingAnimation from '../../../icons/lottieAnimations/smallLoading.json'
import Lottie from "lottie-react";
import { selectMyContractsState, setShouldFillFields } from '../../../features/myContracts/myContractsSlice';
import TransactionHistory from '../dashboard/latesetTransactions/transactionHistory/TransactionHistory'
import ConfirmationDialog from '../../general/ConfirmationDialog'
import MyContractsTest from '../payments/utilities/myContracts/myContractsNew/MyContractsTest';
import { texts } from '../../general/texts'

const validationSchema = yup.object({
    beneficiaryUsername: yup
        .string(texts["message-invalid-user-name"])
        .required(texts["message-invalid-user-name"]),
    amount: yup
        .number(texts["message-invalid-amount"])
        .required(texts["message-invalid-amount"]),
    message: yup
        .string('Enter a message')
})

export const P2P = () => {

    const tabs = [{display:texts["title-transfer"], value:'send'}, {display:texts["title-history"], value:'history'}];
    const dispatch = useDispatch()
    const p2pSliceState = useSelector(selectP2PState)
    const globalSliceState = useSelector(selectGlobalDataState)
    const myContractsSliceState = useSelector(selectMyContractsState)
    const [selectedTab, setSelectedTab] = React.useState(tabs[0].value)
    const userInfo = useSelector(selectUserInfo)

    const formik = useFormik({
        initialValues:{
            token: globalSliceState.token,
            beneficiaryUsername:'',
            amount:'',
            message:'',
            channel: 'WEB'
        },
        validationSchema: validationSchema,
        onSubmit: values => {
            dispatch(sendGeneralRequest({request: {_request: values}, baseUrlKey:'p2p', endpoint:'StartIPE2IPE'}))
        }
    })

    const selectedButtonStyle =
    {
        backgroundColor: colors.lightOrange,
        color: colors.orange,
        fontFamily:'GerberaBold',
        borderRadius: '10px',
        minWidth:'27vh',
        minHeight:'5vh',
        border: '1.5px solid'+ colors.orange,
        textTransform:'none',
        fontSize:'1rem',
        '&:hover': {
            backgroundColor: colors.lightOrange
        }                     
    }
    const defaultButtonStyle =
    {
        backgroundColor: colors.mediumGray,
        color: colors.darkBlue,
        borderRadius: '10px',
        minWidth:'27vh',
        minHeight:'5vh',
        textTransform:'none',
        fontSize:'1rem',
        fontFamily:'GerberaLight',
        '&:hover': {
            backgroundColor: colors.lightOrange
        }
    }

    const handleConfirmation = () => 
    {
        dispatch(sendGeneralRequest({request: {_request: {token: globalSliceState.token, transID: p2pSliceState.transID, channel: 'WEB'}}, baseUrlKey:'p2p', endpoint:'ConfirmIPE2IPE'}))
    }

    React.useEffect(()=>{
        if(p2pSliceState.isTransactionSuccessfullyCompleted)
        {
            dispatch(setGeneralMessage({type: p2pSliceState.success === true ? 'success' : 'error', message: p2pSliceState.responseMessage}))
            dispatch(setTransactionHasBeenMade(true))
            dispatch(clearP2PSliceState())
        }
    },[p2pSliceState.isTransactionSuccessfullyCompleted])

    const useStyles = makeStyles({
        p2pCard:{
            width:'55%',
            height:'600px',
            borderRadius:'20px',
            boxShadow:'0 0 20px #E5E7EA',
            '@media (max-width: 1440px)' : {width:'70%'},
            '@media (max-width: 1024px)' : {width:'80%'},
            '@media (max-width: 899px)' : {width:'90%'}
        },
        historyCard:{
            width:'55%',
            minHeight:'55vh',
            borderRadius:'20px',
            '@media (max-width: 1440px)' : {width:'70%'},
            '@media (max-width: 1024px)' : {width:'80%'},
            '@media (max-width: 899px)' : {width:'90%'}
        },
        contactsCard:{
            width:'65%',
            borderRadius:'20px',
            boxShadow:'0 0 20px #E5E7EA',
            '@media (max-width: 1440px)' : {width:'90%'},
            '@media (max-width: 1024px)' : {width:'100%'},
            '@media (max-width: 899px)' : {width:'90%'}
        },
        button:{
            color:colors.white,
            background:colors.gradientOrange,
            fontFamily:'GerberaBold',
            textTransform:'none',
            marginTop: 50,
            marginBottom: 5,
            width:'90%'
        },
        fieldTitle:{
            color:colors.darkBlue,
            fontSize:'1.5rem',
            fontFamily:'GerberaBold',
            textAlign:'left',
            paddingLeft:'5%',
            paddingTop:'5%'
        },
        textField:{
            width:'90%'
        }
    })

    const classes = useStyles()

    React.useEffect(()=>{
        if(myContractsSliceState.shouldFillFields)
        {
            formik.setFieldValue('beneficiaryUsername', myContractsSliceState.selectedContractInfo.contract)
            dispatch(setShouldFillFields(false))
        }
    },[myContractsSliceState.shouldFillFields])

  return (
    <form>
        <Grid container columnSpacing={6} rowSpacing={7} sx={{background:colors.cyan}} >
            <Grid container item md={12} xs={12} spacing={10} rowSpacing={2} justifyContent='center'  mt={2} >                        
                <ButtonGroup state={tabs} sendValue={setSelectedTab} selectedButtonStyle={selectedButtonStyle}  defaultButtonStyle={defaultButtonStyle}/>                                                                                        
            </Grid>
            {selectedTab === 'send' &&  
            <Grid container item md={12} xs={12} columnSpacing={6} rowSpacing={7} justifyContent={'center'}>
                <Grid container item md={6.5} xs={12} justifyContent={'right'} sx={{'@media (max-width: 899px)' : {justifyContent:'center'}}} >
                <Card className={classes.p2pCard} >
                    <Grid container rowSpacing={5} >
                        <Grid container item md={12} xs={12} mt={2}>
                            <Typography className={classes.fieldTitle} >{texts["title-transfer"]}</Typography>
                        </Grid>
                        <Grid item  md={12} xs={12} mt={5}>
                            <TextField className={classes.textField} id='beneficiaryUsername' color='warning' size='small' label={texts["placeholder-user-p2p"]} name='beneficiaryUsername' onChange={formik.handleChange} value={formik.values.beneficiaryUsername} error={formik.touched.beneficiaryUsername && Boolean(formik.errors.beneficiaryUsername)} helperText={formik.touched.beneficiaryUsername && formik.errors.beneficiaryUsername} />
                        </Grid>
                        <Grid item  md={12} xs={12}>
                            <TextField className={classes.textField}  id='amount' color='warning' size='small' label={texts["placeholder-amount"]} name='amount' type={'number'} onChange={formik.handleChange} value={formik.values.amount} error={formik.touched.amount && Boolean(formik.errors.amount)} helperText={formik.touched.amount && formik.errors.amount} InputProps={{endAdornment: <InputAdornment position="end"  >{texts["currency"]}</InputAdornment>, inputProps: { min: 1 }}}/>
                        </Grid>
                        <Grid item  md={12} xs={12}>
                            <TextField className={classes.textField}  id='message' color='warning' size='small' label={texts["placeholder-beneficiary-comment"]} name='message' onChange={formik.handleChange} value={formik.values.message} />
                        </Grid>
                        <Grid item md={12} xs={12}>
                            <Button disabled={p2pSliceState.isLoading ? true : false} onClick={formik.handleSubmit} className={classes.button} >{texts["button-send"]}</Button>
                        </Grid>
                    </Grid>
                    <Grid container justifyContent={'center'}>
                        <Grid item md={2} xs={2} flex={1} >{p2pSliceState.isLoading && <Lottie animationData={smallLoadingAnimation} loop={true} autoplay={true}/>}</Grid>
                    </Grid>                                                                    
                </Card>
                </Grid>
                <Grid container item md={5.5} xs={12} justifyContent={'left'} sx={{'@media (max-width: 899px)' : {justifyContent:'center'}}} >
                    <MyContractsTest utilityName={'P2P'} currentLocation='utility'/>     
                </Grid>
            </Grid>
            }
            {selectedTab === 'history' &&
            <Grid container item md={12} xs={12} justifyContent={'center'} mt={'-3%'} >
                <TransactionHistory transactionHistory={{tags: [], transactions: userInfo.transactionHistory.transactions.filter(transaction => transaction.serviceName === 'Transferte Parash')}}/>
            </Grid>
            }
            {p2pSliceState.isConfirmationDialogOpen && <ConfirmationDialog handleClose={()=>{dispatch(changeConfirmationDialogState())}} isConfirmationDialogOpen={p2pSliceState.isConfirmationDialogOpen} data={texts["message-confirm-transaction-general"]} handleConfirmationClick={handleConfirmation}/>}      
            {/* {userInfo.accountType !== 3
                ?   <Grid container item md={4.5} justifyContent={'left'} sx={{'@media (max-width: 899px)' : {justifyContent:'center'}}} > 
                        
                    </Grid>
                : <Grid></Grid>       
            }    */}
        </Grid>
    </form>
  )
}
export default P2P
